import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';
import BootstrapVue, { VBModal, VBTooltip } from 'bootstrap-vue';
import vSelect from 'vue-select';

import Ripple from 'vue-ripple-directive';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import flatPickr from 'vue-flatpickr-component';

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('flatPickr', flatPickr);
Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('v-select', vSelect);

Vue.directive('b-modal', VBModal);
Vue.directive('b-tooltip', VBTooltip);
Vue.directive('ripple', Ripple);

Vue.use(BootstrapVue);
